const permissions = {
    
  
    USER_PERMISSIONS: {
      READ: {
        CATEGORIES: 'read_categories',
        TAXES: 'read_taxes',
        SUPPLIERS: 'read_suppliers',
        COURIERS: 'read_couriers',
        CUSTOMERS: 'read_customers',
        PRODUCTS: 'read_products',
        STORES: 'read_stores',
        TEMPLATES: 'read_templates',
        BRANDS: 'read_brand',
        USERS: 'read_users',
        USER_ROLES: 'read_user_roles',
        ATTRIBUTES: 'read_attribute',
        ATTRIBUTES_VALUES: 'read_attribute_values',
        COMPANIES: 'read_company',
        INVOICES: 'read_invoices',
        PURCHASE_ORDERS: 'read_purchase_orders',
        TRANSFERS: 'read_transfers',
        STOCK_ADJUSTMENTS: 'read_stock_adjustment',
        PO_GOOD_RECEIVE_NOTES: 'read_good_receive_notes',
        STOCK_RETURNS: 'read_returns',
        APPROVE_PO_ADMIN: 'approve_purchase_order',
        APPROVE_STR_ADMIN: 'approve_transfer',
        READ_LOOKUP: 'read_lookup',
        READ_UPLOAD_BULK: 'read_upload_bulk',
        READ_DISCOUNT: 'read_discount',
        READ_BULK_DISCOUNT: 'read_bulk_discount'
      },
  
      UPDATE: {
        CATEGORIES: 'update_categories',
        TAXES: 'update_taxes',
        SUPPLIERS: 'update_suppliers',
        COURIERS: 'update_couriers',
        CUSTOMERS: 'update_customers',
        PRODUCTS: 'update_products',
        STORES: 'update_stores',
        TEMPLATES: 'update_templates',
        BRANDS: 'update_brand',
        USERS: 'update_users',
        USER_ROLES: 'update_user_roles',
        ATTRIBUTES: 'update_attribute',
        ATTRIBUTES_VALUES: 'update_attribute_values',
        COMPANIES: 'update_company',
        INVOICES: 'update_invoices',
        PURCHASE_ORDERS: 'update_purchase_orders',
        TRANSFERS: 'update_transfers',
        STOCK_ADJUSTMENTS: 'update_stock_adjustment',
        PO_GOOD_RECEIVE_NOTES: 'update_good_receive_notes',
        STOCK_RETURNS: 'update_returns',
      },
  
      DELETE: {
        CATEGORIES: 'delete_categories',
        TAXES: 'delete_taxes',
        SUPPLIERS: 'delete_suppliers',
        COURIERS: 'delete_couriers',
        CUSTOMERS: 'delete_customers',
        PRODUCTS: 'delete_products',
        STORES: 'delete_stores',
        TEMPLATES: 'delete_templates',
        BRANDS: 'delete_brand',
        USERS: 'delete_users',
        USER_ROLES: 'delete_user_roles',
        ATTRIBUTES: 'delete_attribute',
        ATTRIBUTES_VALUES: 'delete_attribute_values',
        COMPANIES: 'delete_company',
        INVOICES: 'delete_invoices',
        PURCHASE_ORDERS: 'delete_purchase_orders',
        TRANSFERS: 'delete_transfers',
        STOCK_ADJUSTMENTS: 'delete_stock_adjustment',
        PO_GOOD_RECEIVE_NOTES: 'delete_good_receive_notes',
        STOCK_RETURNS: 'delete_returns'
  
      },
  
      WRITE: {
        CATEGORIES: 'write_categories',
        TAXES: 'write_taxes',
        SUPPLIERS: 'write_suppliers',
        COURIERS: 'write_couriers',
        CUSTOMERS: 'write_customers',
        PRODUCTS: 'write_products',
        STORES: 'write_stores',
        TEMPLATES: 'write_templates',
        BRANDS: 'write_brand',
        USERS: 'write_users',
        USER_ROLES: 'write_user_roles',
        ATTRIBUTES: 'write_attribute',
        ATTRIBUTES_VALUES: 'write_attribute_values',
        COMPANIES: 'write_company',
        INVOICES: 'write_invoices',
        PURCHASE_ORDERS: 'write_purchase_orders',
        TRANSFERS: 'write_transfers',
        STOCK_ADJUSTMENTS: 'write_stock_adjustment',
        PO_GOOD_RECEIVE_NOTES: 'write_good_receive_notes',
        STOCK_RETURNS: 'write_returns'
  
      }
  
    },
  
  
  };
  
  export default permissions;
  
